module.exports = __webpack_public_path__ + "static/media/card_271x163_ahorroprotegido@2x.f8e62d1e.png";